import { ViewProperties } from "../../../utils/ViewProperties";
/**
 * Cell properties for the paytable. This does NOT extend Titans cell properties because we are instead using a spine for the paytable.
 */
export class GamePaytableCellProperties extends ViewProperties {
}
export class GamePayTableCellStateProperties extends ViewProperties {
    constructor(label, value) {
        super();
        this.label = label;
        this.value = value;
        if (this.label) {
            this.label.position.y -= this.label.size.y / 2;
        }
        if (this.value) {
            this.value.position.y -= this.value.size.y / 2;
        }
    }
}
//# sourceMappingURL=GamePayTableCellProperties.js.map